import React from 'react';
import { Alert } from 'antd';
import './index.less';

const InvoiceInfo = () => {
  return (
    <div className="invoice-info-container">
      <Alert
        message="开票信息提示"
        description={
          <div className="invoice-info-content">
            <div className="invoice-item">
              <strong>会议编号为 SECZ 的开票信息：</strong>
              <div className="invoice-details">
                <p>发票抬头：智会云（天津）会议展览有限公司</p>
                <p>纳税人登记号：91120222MA069UF33M</p>
              </div>
            </div>
            <div className="invoice-item">
              <strong>会议编号为 HZTL 的开票信息：</strong>
              <div className="invoice-details">
                <p>发票抬头：汇智通联（天津）信息科技有限公司</p>
                <p>纳税人登记号：91120222MADQNUQT47</p>
              </div>
            </div>
          </div>
        }
        type="info"
        showIcon
      />
    </div>
  );
};

export default InvoiceInfo;
